import clsx from 'clsx';

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'sm' | 'md';
  label?: string;
}

export function IconButton({ size = 'md', label, className, children, ...props }: IconButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      className={clsx(
        'inline-flex items-center justify-center rounded-full text-daynote-muted hover:text-daynote-text hover:bg-white/10 transition-colors border-none bg-transparent cursor-pointer',
        size === 'sm' ? 'w-8 h-8' : 'w-9 h-9',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
